import { gql } from '@apollo/client';

export const BLACKLIST_AUTHOR = gql`
  mutation blacklistAuthor(
    $author: String!
    $permlink: String
    $reason: String
    $isOnlyCommentBlacklisted: Boolean
  ) {
    blacklistAuthor(
      author: $author
      permlink: $permlink
      reason: $reason
      isOnlyCommentBlacklisted: $isOnlyCommentBlacklisted
    ) {
      success
      message
    }
  }
`;

export const UNBLACKLIST_AUTHOR = gql`
  mutation unblacklistAuthor(
    $author: String!
    $reason: String
    $isOnlyCommentBlacklisted: Boolean
  ) {
    unblacklistAuthor(
      author: $author
      reason: $reason
      isOnlyCommentBlacklisted: $isOnlyCommentBlacklisted
    ) {
      success
      message
    }
  }
`;

export const BLACKLIST_POST = gql`
  mutation blacklistPost(
    $author: String!
    $permlink: String!
    $reason: String
    $isShadow: Boolean
    $isComment: Boolean
  ) {
    blacklistPost(
      author: $author
      permlink: $permlink
      reason: $reason
      isShadow: $isShadow
      isComment: $isComment
    ) {
      success
      message
    }
  }
`;

export const UNBLACKLIST_POST = gql`
  mutation unblacklistPost(
    $author: String!
    $permlink: String!
    $reason: String
    $isComment: Boolean
  ) {
    unblacklistPost(
      author: $author
      permlink: $permlink
      reason: $reason
      isComment: $isComment
    ) {
      success
      message
    }
  }
`;

export const IS_BLACKLISTED_POST = gql`
  query isBlacklistedPost(
    $author: String!
    $permlink: String!
    $isComment: Boolean
  ) {
    isBlacklistedPost(
      author: $author
      permlink: $permlink
      isComment: $isComment
    ) {
      isBlacklisted
      reason
      isShadow
    }
  }
`;

export const IS_BLACKLISTED_AUTHOR = gql`
  query isBlacklistedAuthor($author: String!) {
    isBlacklistedAuthor(author: $author) {
      isBlacklisted
      reason
      isOnlyCommentBlacklisted
    }
  }
`;
